import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router'
import { HStack, styled } from '../styled-system/jsx'

interface BreadcrumbItem {
    readonly label: string
    readonly to?: string
}

interface PageNavigationProps {
    readonly items: readonly BreadcrumbItem[]
}

const NavigationLink = styled(Link)

export function PageNavigation({ items }: PageNavigationProps) {
    return (
        <HStack as="nav" aria-label="Breadcrumb" color="fg.muted" fontSize="sm">
            <HStack as="ol" gap="2" listStyleType="none" flexWrap="wrap" aria-label="Breadcrumb">
                {items.map((item, index) => {
                    const isCurrent = index === items.length - 1
                    return (
                        <HStack as="li" key={`${item.label}-${index}`} gap="2">
                            {index > 0 && <ChevronRight size={14} aria-hidden="true" />}
                            {item.to && !isCurrent ? (
                                <NavigationLink to={item.to} color="fg.muted" textDecoration="none" _hover={{ color: 'fg.default' }}>
                                    {item.label}
                                </NavigationLink>
                            ) : (
                                <styled.span
                                    color={isCurrent ? 'fg.default' : 'fg.muted'}
                                    fontWeight={isCurrent ? 'medium' : 'normal'}
                                    aria-current={isCurrent ? 'page' : undefined}
                                >
                                    {item.label}
                                </styled.span>
                            )}
                        </HStack>
                    )
                })}
            </HStack>
        </HStack>
    )
}
